module.exports = __webpack_public_path__ + "img/quotas.9dbe9dc7.svg";